import type { Component } from "react"

import { isUpdateSignal } from "@/lib/react_performance/isUpdateSignal"

import type { ReactPerformance } from "."

export const curryShouldUpdateWithManagedState = <
  Props,
  State extends ReactPerformance.ManagedState
>(
  component: Component<Props, State>,
  manageState: ReactPerformance.Functions.ManageState<Props, State>
): ReactPerformance.Functions.ShouldComponentUpdate<Props, State> => {
  return (nextProps, nextState) => {
    if (isUpdateSignal(nextState)) {
      component.setState({ update: false })
      return true
    }

    if (component.state.update && !nextState.update) {
      return false
    }

    const changes = manageState({ nextProps, nextState })
    if (changes) {
      if (isUpdateSignal(changes)) {
        return true
      }

      component.setState({
        update: true,
        ...changes,
      } as State)
    }

    return false
  }
}
